<template>
  <div class="container-fluid">
    <div class="unit-details">
      <div>
        <h3 class="mb-4">{{ unitDetails.description }}</h3>

        <div class="row mb-3">
          <div class="col-md-6">
            <div class="unit">
              <div class="d-flex head">
                <div>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink"
                    xmlns:svgjs="http://svgjs.com/svgjs"
                    version="1.1"
                    width="25"
                    height="25"
                    x="0"
                    y="0"
                    viewBox="0 0 426.667 426.667"
                    style="enable-background: new 0 0 512 512"
                    xml:space="preserve"
                  >
                    <g>
                      <g xmlns="http://www.w3.org/2000/svg">
                        <g>
                          <path
                            d="M362.667,384V0H64v384H21.333v42.667h384V384H362.667z M192,42.667h42.667v42.667H192V42.667z M192,128h42.667v42.667H192    V128z M192,213.333h42.667V256H192V213.333z M149.333,256h-42.667v-42.667h42.667V256z M149.333,170.667h-42.667V128h42.667    V170.667z M149.333,85.333h-42.667V42.667h42.667V85.333z M256,384h-85.333v-42.667c0-23.467,19.2-42.667,42.667-42.667    S256,317.867,256,341.333V384z M320,256h-42.667v-42.667H320V256z M320,170.667h-42.667V128H320V170.667z M320,85.333h-42.667    V42.667H320V85.333z"
                            fill="#000000"
                            data-original="#000000"
                          />
                        </g>
                      </g>
                      <g xmlns="http://www.w3.org/2000/svg"></g>
                      <g xmlns="http://www.w3.org/2000/svg"></g>
                      <g xmlns="http://www.w3.org/2000/svg"></g>
                      <g xmlns="http://www.w3.org/2000/svg"></g>
                      <g xmlns="http://www.w3.org/2000/svg"></g>
                      <g xmlns="http://www.w3.org/2000/svg"></g>
                      <g xmlns="http://www.w3.org/2000/svg"></g>
                      <g xmlns="http://www.w3.org/2000/svg"></g>
                      <g xmlns="http://www.w3.org/2000/svg"></g>
                      <g xmlns="http://www.w3.org/2000/svg"></g>
                      <g xmlns="http://www.w3.org/2000/svg"></g>
                      <g xmlns="http://www.w3.org/2000/svg"></g>
                      <g xmlns="http://www.w3.org/2000/svg"></g>
                      <g xmlns="http://www.w3.org/2000/svg"></g>
                      <g xmlns="http://www.w3.org/2000/svg"></g>
                    </g>
                  </svg>
                </div>
                <div>
                  <h4>{{ unitDetails.description }}</h4>
                </div>
              </div>

              <h6 class="d-flex" style="gap: 15px">
                <div>
                  <h5>السعر</h5>
                </div>
                <div>
                  <h6 class="mb-0 mt-1">
                    {{ unitDetails.cost.toLocaleString("en-US") }} EGP
                  </h6>
                </div>
              </h6>

              <h6 class="d-flex mt-2" style="gap: 15px">
                <div>
                  <h5>تاريخ الإنشاء</h5>
                </div>
                <div>
                  <h6>
                    {{ $moment(unitDetails.created_at).locale("ar").fromNow() }}
                  </h6>
                </div>
              </h6>
            </div>
          </div>

          <div class="col-md-6">
            <div class="client" v-if="unitDetails.client">
              <div class="d-flex head">
                <div>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink"
                    xmlns:svgjs="http://svgjs.com/svgjs"
                    version="1.1"
                    width="25"
                    height="25"
                    x="0"
                    y="0"
                    viewBox="0 0 512 512"
                    style="enable-background: new 0 0 512 512"
                    xml:space="preserve"
                  >
                    <g>
                      <g xmlns="http://www.w3.org/2000/svg">
                        <g>
                          <path
                            d="M437.02,330.98c-27.883-27.882-61.071-48.523-97.281-61.018C378.521,243.251,404,198.548,404,148    C404,66.393,337.607,0,256,0S108,66.393,108,148c0,50.548,25.479,95.251,64.262,121.962    c-36.21,12.495-69.398,33.136-97.281,61.018C26.629,379.333,0,443.62,0,512h40c0-119.103,96.897-216,216-216s216,96.897,216,216    h40C512,443.62,485.371,379.333,437.02,330.98z M256,256c-59.551,0-108-48.448-108-108S196.449,40,256,40    c59.551,0,108,48.448,108,108S315.551,256,256,256z"
                            fill="#000000"
                            data-original="#000000"
                          />
                        </g>
                      </g>
                      <g xmlns="http://www.w3.org/2000/svg"></g>
                      <g xmlns="http://www.w3.org/2000/svg"></g>
                      <g xmlns="http://www.w3.org/2000/svg"></g>
                      <g xmlns="http://www.w3.org/2000/svg"></g>
                      <g xmlns="http://www.w3.org/2000/svg"></g>
                      <g xmlns="http://www.w3.org/2000/svg"></g>
                      <g xmlns="http://www.w3.org/2000/svg"></g>
                      <g xmlns="http://www.w3.org/2000/svg"></g>
                      <g xmlns="http://www.w3.org/2000/svg"></g>
                      <g xmlns="http://www.w3.org/2000/svg"></g>
                      <g xmlns="http://www.w3.org/2000/svg"></g>
                      <g xmlns="http://www.w3.org/2000/svg"></g>
                      <g xmlns="http://www.w3.org/2000/svg"></g>
                      <g xmlns="http://www.w3.org/2000/svg"></g>
                      <g xmlns="http://www.w3.org/2000/svg"></g>
                    </g>
                  </svg>
                </div>
                <div>
                  <h4>{{ unitDetails.client.name }}</h4>
                </div>
              </div>

              <h6 class="d-flex mt-2" style="gap: 15px">
                <div>
                  <h5>العنوان</h5>
                </div>
                <div>
                  <h6>
                    {{ unitDetails.client.address }}
                  </h6>
                </div>
              </h6>

              <h6 class="d-flex mt-2" style="gap: 15px">
                <div>
                  <h5>الهاتف</h5>
                </div>
                <div>
                  <h6>
                    {{ unitDetails.client.phone }}
                  </h6>
                </div>
              </h6>

              <h6 class="d-flex mt-2 justify-content-between flex-wrap" style="gap: 15px">
                <div class="d-flex" style="gap: 15px; align-items: center">
                  <h5>مقدم الشقة</h5>
                  <h6>
                    {{ unitDetails.down_payment.toLocaleString("en-US") }}
                  </h6>
                </div>
                <div class="d-flex" style="gap: 15px; align-items: center">
                  <h5>الاقساط</h5>
                  <h6>{{ init.toLocaleString("en-US") }}</h6>
                </div>
                <div class="d-flex" style="gap: 15px; align-items: center">
                  <h5>اجمالي المسدد</h5>
                  <h6>
                    {{
                      (unitDetails.down_payment + init).toLocaleString("en-US")
                    }}
                  </h6>
                </div>
                <div class="d-flex" style="gap: 15px; align-items: center">
                  <h5>المتبقي</h5>
                  <h6>{{ residual.toLocaleString("en-US") }}</h6>
                </div>
              </h6>
            </div>

            <div v-else>
              <vs-button
                @click="openSaleUnitModel = true"
                style="padding: 5px 15px"
                >بيع الوحدة</vs-button
              >
            </div>
          </div>

          <div class="col-md-12">
            <div>
              <div class="mt-4 mb-4 d-flex table-head">
                <div>
                  <h4>أقساط السداد</h4>
                </div>
                <div>
                  <vs-button
                    style="padding: 3px 15px"
                    @click="openAddInstallmentModel = true"
                    >إضافة قسط</vs-button
                  >
                </div>
              </div>

              <el-table
                style="width: 100%"
                :data="unitDetails.unit_installment"
                class="table-mobile"
              >
                <el-table-column type="index" label="#" class-name="display-mobile-none" />

                <el-table-column prop="paied_at" label="وقت السداد">
                  <template slot-scope="scope">
                    <span class="label">{{ scope.$index + 1 }} # وقت السداد</span>
                    <div>{{ scope.row.paied_at }}</div>
                  </template>
                </el-table-column>

                <el-table-column prop="amount" label="القيمة">
                  <template slot-scope="scope">
                    <span class="label">القيمة</span>
                    <div>{{ scope.row.amount }}</div>
                  </template>
                </el-table-column>

                <el-table-column prop="paied" label="تم الدفع">
                  <template slot-scope="scope">
                    <span class="label">تم الدفع</span>
                    <div>{{ scope.row.paied }}</div>
                  </template>
                </el-table-column>

                <el-table-column label="الحالة">
                  <template slot-scope="scope">
                    <span class="label">الحالة</span>
                    <div>
                      <span
                        class="status success"
                        v-if="!(scope.row.amount > scope.row.paied)"
                      >
                        تم السداد
                      </span>
                      <span class="status danger" v-else>لم يتم السداد</span>
                    </div>
                  </template>
                </el-table-column>

                <el-table-column label="الاجراءات">
                  <template slot-scope="scope">
                    <vs-button
                      style="font-size: 13px; padding: 1px 15px; margin: 10px"
                      :disabled="!(scope.row.amount > scope.row.paied)"
                      @click="openBuyInstall(scope.row)"
                      size="small"
                    >
                      سداد
                    </vs-button>
                    <vs-button
                      style="font-size: 13px; padding: 1px 15px; margin: 10px"
                      @click="openUpdateInstallements(scope.row)"
                      size="small"
                      color="rgb(134, 4, 98)"
                      type="filled"
                    >
                      تعديل
                    </vs-button>
                  </template>
                </el-table-column>

                <el-table-column type="expand">
                  <template slot-scope="props">
                    <div class="row">
                      <div
                        class="col-md-3 mb-2"
                        v-for="payment in props.row.payments"
                        :key="payment.id"
                      >
                        <div class="payment-deal">
                          <table class="table table-bordered">
                            <tr>
                              <td>التاريخ</td>
                              <td>
                                {{ $moment(payment.created_at).format("llll") }}
                              </td>
                            </tr>
                            <tr>
                              <td>الوصف</td>
                              <td v-if="payment.description">
                                {{ payment.description }}
                              </td>
                              <td v-else class="text-danger">لا يوجد</td>
                            </tr>

                            <tr>
                              <td>المبلغ</td>
                              <td>{{ payment.amount }}</td>
                            </tr>

                            <tr>
                              <td></td>
                              <td>
                                <el-popconfirm
                                  confirm-button-text="موافق"
                                  cancel-button-text="إلغاء"
                                  icon="el-icon-info"
                                  icon-color="red"
                                  title="هل تريد مسح الدفعه؟"
                                  @confirm="deleteInstallmentPayment(payment)"
                                >
                                  <div slot="reference">
                                    <vs-button
                                      style="
                                        font-size: 13px;
                                        padding: 1px 15px;
                                        margin: 10px;
                                      "
                                      size="small"
                                      color="#ff0000"
                                      type="filled"
                                    >
                                      مسح
                                    </vs-button>
                                  </div>
                                </el-popconfirm>
                              </td>
                            </tr>
                          </table>
                        </div>
                      </div>
                    </div>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
        </div>
      </div>
    </div>

    <vs-popup
      class="popup-width-300"
      title="إضافة قسط جديد"
      :active.sync="openAddInstallmentModel"
    >
      <div class="popup-calender">
        <el-form :model="addInstallment" ref="addInstallment">
          <h6 class="mb-1">
            المبلغ

            <span class="mr-5" v-if="addInstallment.amount"
              >( {{ convertNumber(addInstallment.amount) }} )</span
            >
          </h6>
          <el-form-item
            prop="amount"
            :rules="[{ required: true, message: 'المبلغ مطلوب' }]"
          >
            <el-input
              type="number"
              @focus="$event.target.select()"
              placeholder="المبلغ"
              v-model="addInstallment.amount"
            ></el-input>
          </el-form-item>

          <h6 class="mb-1">وقت الدفع</h6>
          <el-form-item
            prop="paied_at"
            :rules="[{ required: true, message: 'وقت الدفع مطلوب' }]"
          >
            <el-date-picker
              style="width: 100%"
              type="date"
              value-format="yyyy-MM-dd"
              placeholder="ميعاد التحصيل"
              v-model="addInstallment.paied_at"
            >
            </el-date-picker>
          </el-form-item>

          <el-form-item>
            <div>
              <el-button type="primary" @click="onSubmit('addInstallment')">
                إضافة
              </el-button>
            </div>
          </el-form-item>
        </el-form>
      </div>
    </vs-popup>

    <vs-popup
      class="popup-width-300"
      title="إضافة تحصيل دفعة من القسط "
      :active.sync="openBuyInstallModel"
    >
      <div class="popup-calender">
        <el-form :model="buyInstall" ref="buyInstallForm">
          <div class="d-flex mb-3" style="justify-content: space-between">
            <div class="d-flex">
              <h5>إجمالي المبلغ :</h5>
              <span> {{ currInstall.amount }} <span>EGP</span> </span>
            </div>
            <div class="d-flex">
              <h5>المدفوع :</h5>
              <span> {{ currInstall.paied }} <span>EGP</span> </span>
            </div>
          </div>
          <h6 class="mb-1">
            المبلغ
            <span class="mr-5" v-if="buyInstall.amount"
              >( {{ convertNumber(buyInstall.amount) }} )</span
            >
          </h6>
          <el-form-item
            prop="amount"
            :rules="[{ required: true, message: 'المبلغ مطلوب' }]"
          >
            <el-input
              type="number"
              @focus="$event.target.select()"
              placeholder="المبلغ"
              v-model="buyInstall.amount"
            ></el-input>
          </el-form-item>

          <el-form-item>
            <el-form-item label="ملاحظات ">
              <input
                class="form-control mb-2"
                v-model="buyInstall.description"
                autocomplete="off"
                @focus="$event.target.select()"
              />
            </el-form-item>
            <div>
              <el-button
                type="primary"
                @click="onSubmitBuyInstall('buyInstallForm')"
              >
                إضافة
              </el-button>
            </div>
          </el-form-item>
        </el-form>
      </div>
    </vs-popup>

    <vs-popup
      class="popup-width-300"
      title="إضافة قسط جديد"
      :active.sync="openSaleUnitModel"
    >
      <div class="popup-calender">
        <el-form :model="saleUnit" ref="saleUnit">
          <h6 class="mb-1">اختر العميل</h6>
          <el-form-item
            prop="client_id"
            :rules="[{ required: true, message: 'تحديد العميل مطلوب' }]"
          >
            <el-select
              v-model="saleUnit.client_id"
              style="width: 100% !important"
              placeholder="العميل"
            >
              <el-option
                v-for="item in clients"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item>
            <div>
              <el-button type="primary" @click="onSubmitSaleUnit('saleUnit')">
                إضافة
              </el-button>
            </div>
          </el-form-item>
        </el-form>
      </div>
    </vs-popup>

    <vs-popup
      class="popup-width-300"
      title="تعديل قسط "
      :active.sync="updateInstallmentModel"
    >
      <div class="popup-calender">
        <el-form :model="currInstallment" ref="buyInstall">
          <div class="d-flex mb-3" style="justify-content: space-between">
            <div class="d-flex">
              <h5>إجمالي المبلغ :</h5>
              <span> {{ currInstallmentAmount }} <span>EGP</span> </span>
            </div>
            <div class="d-flex">
              <h5>المدفوع :</h5>
              <span> {{ currInstallment.paied }} <span>EGP</span> </span>
            </div>
          </div>
          <h6 class="mb-1">
            المبلغ
            <span class="mr-5" v-if="currInstallment.amount"
              >( {{ convertNumber(currInstallment.amount) }} )</span
            >
          </h6>
          <el-form-item
            prop="amount"
            :rules="[{ required: true, message: 'المبلغ مطلوب' }]"
          >
            <el-input
              placeholder="المبلغ"
              v-model="currInstallment.amount"
            ></el-input>
          </el-form-item>

          <h6 class="mb-1">وقت الدفع</h6>
          <el-form-item
            prop="paied_at"
            :rules="[{ required: true, message: 'وقت الدفع مطلوب' }]"
          >
            <el-date-picker
              style="width: 100%"
              type="date"
              value-format="yyyy-MM-dd"
              placeholder="ميعاد التحصيل"
              v-model="currInstallment.paied_at"
            >
            </el-date-picker>
          </el-form-item>

          <el-form-item>
            <div>
              <el-button type="primary" @click="submitUpdateInstallment()">
                تعديل
              </el-button>
            </div>
          </el-form-item>
        </el-form>
      </div>
    </vs-popup>
  </div>
</template>

<script>
import axiosApi from "@/plugins/axios.js";
export default {
  async created() {
    this.getClients();
    this.getProjectUnit();
    this.getProjectDetails();
  },
  computed: {
    residual() {
      return this.unitDetails.cost - this.unitDetails.down_payment - this.init;
    },
  },
  data() {
    return {
      openSaleUnitModel: false,
      unitDetails: {},
      buyInstall: {},
      all: 0,
      init: 0,
      addInstallment: {},
      openAddInstallmentModel: false,
      currInstall: {},
      clients: [],
      saleUnit: {},
      openBuyInstallModel: false,
      currInstallment: {},
      updateInstallmentModel: false,
      currInstallmentAmount: 0,
    };
  },

  methods: {
    convertNumber(val) {
      if (val > 0) {
        return Number(val).toLocaleString("en-US");
      } else {
        return "";
      }
    },
    async submitUpdateInstallment() {
      if (this.currInstallment.amount < this.currInstallment.paied) {
        this.$vs.notify({
          title: "خطأ",
          position: "top-center",
          color: "danger",
          text: "يجب ان يكون الاجمالي اكبر من المبلغ المدفوع",
        });
        return;
      }
      const loading = this.$loading({
        lock: true,
        text: false,
        spinner: "el-icon-loading",
        background: "rgba(255,255,255,.7)",
        customClass: "fullscreen-loading",
      });

      try {
        await axiosApi.put(`/unit_installments/${this.currInstallment.id}`, {
          ...this.currInstallment,
        });
        this.$vs.notify({
          title: "تم بنجاح",
          position: "top-center",
          color: "success",
          text: "تم التعديل بنجاح",
        });
        this.updateInstallmentModel = false;
        this.getClients();
        this.getProjectUnit();
      } catch {
        this.$vs.notify({
          title: "خطأ",
          position: "top-center",
          color: "danger",
          text: "حدث خطأ ما",
        });
      } finally {
        loading.close();
      }
    },

    deleteInstallmentPayment(payment) {
      // unit_installments/payments/
      const loading = this.$loading({
        lock: true,
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      axiosApi
        .delete(`unit_installments/payments/${payment.id}`)
        .then(() => {
          this.getProjectUnit();
          this.$notify({
            title: "تمت العملية بنجاح",
            message: "تم مسح بيانات المنتج بنجاح",
            type: "success",
            duration: 1500,
          });
        })
        .catch((e) => {
          this.$notify.error({
            title: "حدث خطأ",
            message: "عفوا تأكد من بيانات المطلوبة",
            duration: 1500,
          });
          console.log(e);
        })
        .finally(() => loading.close());
    },
    openUpdateInstallements(installment) {
      this.currInstallment = { ...installment };
      this.currInstallmentAmount = this.currInstallment.amount;
      this.updateInstallmentModel = true;
    },
    onSubmitSaleUnit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          axiosApi
            .post(`/clients/units`, {
              ...this.saleUnit,
              id: this.$route.params.id,
            })
            .then(() => {
              this.getProjectUnit();
              this.$vs.notify({
                title: "تم بنجاح",
                position: "top-center",
                color: "success",
                text: "تم البيع بنجاح",
              });
              this.openSaleUnitModel = false;
            });
        }
      });
    },
    getClients() {
      const loading = this.$loading({
        lock: true,
        text: false,
        spinner: "el-icon-loading",
        background: "rgba(255,255,255,.7)",
        customClass: "fullscreen-loading",
      });
      axiosApi
        .get(`/clients`)
        .then((res) => {
          this.clients = res.data;
        })
        .finally(() => loading.close());
    },
    onSubmitBuyInstall(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          console.log("hi");
          if (
            this.buyInstall.amount >
            this.currInstall.amount - this.currInstall.paied
          ) {
            this.$vs.notify({
              title: "قيمة القسط اكبر من المبلغ المتبقي",
              position: "top-center",
              color: "danger",
              text: "القيمة اكبر من الاجمالي",
            });
            return;
          }

          if (this.buyInstall.amount <= 0) {
            this.$vs.notify({
              title: "رقم غير صالح",
              position: "top-center",
              color: "danger",
              text: "القيمة يجب ان تكون اكبر من الصفر",
            });
            return;
          }
          axiosApi
            .post(`/unit_installments/payments`, {
              amount: this.buyInstall.amount,
              description: this.buyInstall.description,
              unit_installment_id: this.currInstall.id,
            })
            .then(() => {
              this.openBuyInstallModel = false;
              this.$vs.notify({
                title: "تم بنجاح",
                position: "top-center",
                color: "success",
                text: "تم السداد بنجاح",
              });

              this.buyInstall = {};

              this.getProjectUnit();
            });
        }
      });
    },
    openBuyInstall(install) {
      this.currInstall = { ...install };
      this.openBuyInstallModel = true;
    },
    onSubmit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.addInstallment.amount <= 0) {
            this.$vs.notify({
              title: "رقم غير صالح",
              position: "top-center",
              color: "danger",
              text: "القيمة يجب ان تكون اكبر من الصفر",
            });
            return;
          }
          if (
            this.unitDetails.cost - this.all - this.unitDetails.down_payment <=
            0
          ) {
            this.$vs.notify({
              title: "لا يمكنك إضافة قسط اخر",
              position: "top-center",
              color: "danger",
              text: "الاقساط الموجودة حاليا تساوي مبلغ الوحدة",
            });
            return;
          }

          if (this.addInstallment.amount > this.residual) {
            this.$vs.notify({
              title: "لا يمكنك إضافة قسط بهذا المبلغ",
              position: "top-center",
              color: "danger",
              text: "المبلغ اكبر من المتبقي",
            });
            return;
          }
          const loading = this.$loading({
            lock: true,
            text: false,
            spinner: "el-icon-loading",
            background: "rgba(255,255,255,.7)",
            customClass: "fullscreen-loading",
          });
          axiosApi
            .post("/unit_installments", {
              amount: this.addInstallment.amount,
              paied_at: this.$moment(this.addInstallment.paied_at).format(
                "YYYY-MM-DD"
              ),
              project_unit_id: this.$route.params.id,
            })
            .then(() => {
              this.$vs.notify({
                title: "تم بنجاح",
                position: "top-center",
                color: "success",
                text: "تم الإضافة بنجاح",
              });
              this.getProjectUnit();
              this.addInstallment = {};
              this.openAddInstallmentModel = false;
            })
            .finally(() => loading.close());
        }
      });
    },
    initBalance() {
      let unitPaied = this.unitDetails.unit_installment.map((ele) => {
        return ele.paied;
      });
      console.log("unitPaied", unitPaied);

      let init = unitPaied.reduce((prev, curr) => {
        return Number(prev) + Number(curr);
      }, 0);
      console.log(init);

      return init;
    },

    allBalance() {
      let unitAmount = this.unitDetails.unit_installment.map((ele) => {
        return ele.amount;
      });

      console.log("unitAmount", unitAmount);

      let init = unitAmount.reduce(
        (prev, curr) => Number(prev) + Number(curr),
        0
      );
      return init;
    },
    getProjectUnit() {
      const loading = this.$loading({
        lock: true,
        text: false,
        spinner: "el-icon-loading",
        background: "rgba(255,255,255,.7)",
        customClass: "fullscreen-loading",
      });
      axiosApi
        .get(`/project_units/${this.$route.params.id}`)
        .then((res) => {
          this.unitDetails = res.data;
          this.all = this.allBalance();
          this.init = this.initBalance();
        })
        .finally(() => loading.close());
    },
  },
};
</script>

<style lang="scss">
.unit-details {
  padding: 10px;

  .payment-deal {
    table {
      width: 100%;
      padding: 5px;
      background: #f7f7f7;
      margin-top: 5px;
      tr {
        td {
          text-align: center !important;
          line-height: 2;
        }
      }
    }
  }
  .status {
    padding: 5px 10px;
    border-radius: 10px;
    color: #fff;
    text-align: center;

    &.danger {
      border: 1px solid #ffe5e5;
      color: #ff0000;
      background: #ffe5e5;
    }
    &.success {
      border: 1px solid #f2f9f1;
      color: #79ce73;
      background: #f2f9f1;
    }
  }

  .client {
    padding: 20px 15px;
    background: #fff;

    box-shadow: 0 4px 25px 0 #00000008;
    border-radius: 13px;
    .head {
      gap: 10px;
      svg {
        padding: 5px;
        background-color: rgba(var(--vs-primary), 0.3) !important;
        border-radius: 5px;
        path {
          fill: #fff;
        }
      }
    }
  }
  .unit {
    padding: 20px 15px;
    background: #fff;
    box-shadow: 0 4px 25px 0 #00000008;
    border-radius: 13px;
    min-height: 147px;

    .head {
      gap: 10px;
      svg {
        padding: 5px;
        background-color: rgba(var(--vs-primary), 0.3) !important;
        border-radius: 5px;
        path {
          fill: #fff;
        }
      }
    }
    h6 {
      svg {
        path {
          fill: #ffcc33;
        }
      }
    }
  }

  .table-head {
    justify-content: space-between;
  }

  .el-date-editor {
    .el-input {
      width: 100% !important;
    }
  }
}

.el-date-picker {
  z-index: 99999999999999 !important;
  * {
    text-align: center !important;
  }
}
</style>
